export default "__VITE_ASSET__rUkYvChe__"